import { Injectable, HostListener } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';

// Menu
export interface Menu {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	children?: Menu[];
}

@Injectable({
	providedIn: 'root'
})

export class NavService {

	public screenWidth: any
	public collapseSidebar: boolean = false
	public fullScreen = false;

	constructor() {
		this.onResize();
		if (this.screenWidth < 991) {
			this.collapseSidebar = true
		}
	}

	// Windows width
	@HostListener('window:resize', ['$event'])
	onResize(event?:any) {
		this.screenWidth = window.innerWidth;
	}

	MENUITEMS: Menu[] = [
		{
			title: 'Dashboard', icon: 'home', type: 'link', badgeType: 'primary',path: '/master/ViewSeller', active: true, 
		},
		{
			title: 'Categories', icon: 'list', type: 'sub', badgeType: 'primary', active: false, children: [
				{ path: '/master/ViewCategory1', title: 'Level1 Category', type: 'link',active: true },				
				{ path: '/master/ViewCategory2', title: 'Level2 Category', type: 'link',active: true },			
				{ path: '/master/ViewCategory3', title: 'Level3 Category', type: 'link',active: true },					
			]
		},
		{
			title: 'Brand', icon: 'bookmark', type: 'link', badgeType: 'primary',path: '/master/Viewbrand', active: false
		},
		{
			title: 'Manufacturer', icon: 'package', type: 'link', badgeType: 'primary',path: '/master/Viewmanu', active: false
		},
		{
			title: 'Storage Location', icon: 'home', type: 'link', badgeType: 'primary',path: '/master/ViewSeller', active: false
		},
		{
			title: 'Customer', icon: 'home', type: 'link', badgeType: 'primary',path: '/master/ViewCustomer', active: false
		},
		{
			title: 'Vendor', icon: 'shopping-bag', type: 'link', badgeType: 'primary',path: '/master/ViewVendor', active: false
		},
		{
			title: 'Delivery Route', icon: 'shopping-bag', type: 'link', badgeType: 'primary',path: '/master/ViewDeliveryRoute', active: false
		},	
		{
			title: 'Delivery User', icon: 'shopping-bag', type: 'link', badgeType: 'primary',path: '/master/ViewDeliveryUser', active: false
		}/*,
		{
			title: 'Pickup Point', icon: 'shopping-bag', type: 'link', badgeType: 'primary',path: '/master/ViewPickupPoint', active: false
		},
			
		,
		{
			title: 'Banner', icon: 'image', type: 'link', badgeType: 'primary',path: '/master/ViewBanner', active: false
		},		
		{
			title: 'Collections', icon: 'list', type: 'link', badgeType: 'primary',path: '/master/ViewCollections', active: false
		}*/,
		{
			title: 'Product', icon: 'tag', type: 'sub', badgeType: 'primary', active: false, children: [
				{ path: '/master/AddProductLoc', title: 'Add Product', type: 'link' },				
				{ path: '/master/ViewProduct', title: 'View Product', type: 'link' },				
				//{ path: '/master/CollectionsProduct', title: 'Add Collections Product', type: 'link' },							
				{ path: '/master/ProductEnabled', title: 'Enbled Products', type: 'link' },							
				{ path: '/master/ProductDisabled', title: 'Disabled Products', type: 'link' },							
				//{ path: '/master/ProductRectification', title: 'Rectification Products', type: 'link' },							
			]
		},
		{
			title: 'Orders', icon: 'tag', type: 'sub', badgeType: 'primary', active: false, children: [
				{ path: '/master/CreateOrder', title: 'Create Order', type: 'link' },
				{ path: '/master/CreateOrderRoute', title: 'Create Route Order ', type: 'link' },
				{ path: '/master/PendingOrders', title: 'Pending Orders', type: 'link' },
				{ path: '/master/DespatchOrders', title: 'Despatch Orders', type: 'link' },
				{ path: '/master/CancelOrders', title: 'Cancel Orders', type: 'link' },
				{ path: '/master/Reports', title: 'Reports', type: 'link' },	
			]
		},
		{
			title: 'Company', icon: 'settings', type: 'sub', badgeType: 'primary', active: false,children: [
				{ path: '/master/editbank', title: 'Add Bank Account', type: 'link' },
				{ path: '/master/editaddress', title: 'Edit Address', type: 'link' },				
				{ path: '/master/editregister', title: 'Edit Registration', type: 'link' },
				{ path: '/master/editmedia', title: 'Edit Media Information', type: 'link' },
				{ path: '/master/editbilling', title: 'Edit Billing Address', type: 'link' },
				{ path: '/master/editaboutus', title: 'Edit About us', type: 'link' },										
			]
		},
		{
			title: 'User Admin', icon: 'user', type: 'link', badgeType: 'primary',path: '/master/ViewUserAdmin', active: false
		}/*,
		{
			title: 'User Storage Location', icon: 'user', type: 'link', badgeType: 'primary',path: '/master/ViewUserLocation', active: false
		}*/
		,
		{
			title: 'Logout', icon: 'log-out', type: 'link', badgeType: 'primary',path: '/dashboard/Logout', active: false
		}
		
		
	]
	// Array
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);


}
